import React, { useContext } from 'react'
import axios from 'axios'
import { StateContext } from "../../App";

function SendNotification() {
    const { dispatch } = useContext(StateContext);

    const handleFormSubmit = () => {
        window.event.preventDefault();
        dispatch({ type: "SET_LOADING", payload: true });

        const form = document.querySelector('#notificatiion_message_panel');
        const email = form.email.value;
        const body = form.body.value;

        const options = {email, body}

        axios.put('/admin/notification', options)
        .then(res => {
            console.log(res.data)
            dispatch({ type: "SET_LOADING", payload: false });
            res.data.error ?
            alert(res.data.error) :
            alert(`Notification sent successfully to ${res.data.user.email}`);
            form.body.value = '';
        })
        .catch(e => {
            dispatch({ type: "SET_LOADING", payload: false });
            console.log(e);
        })

    }

    return (
        <div className="snd_notification">
            <div className="container">
                <div className="card indigo darken-3">
                    <div className="card-content">
                        <h5>Write A Notification</h5>
                        <form id="notificatiion_message_panel" onSubmit={handleFormSubmit}>
                            <input name="email" type="email" placeholder="Write to < emailAddress >" required />
                            <textarea name="body" placeholder="write a notification..." required>
                                
                            </textarea>
                            <button>Send Notification Message</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SendNotification
